// here we add all base urls and keys
export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
export const s3baseUrl = process.env.REACT_APP_PIC_BASE_URL;
export const website_url = process.env.REACT_APP_WEBSITE_URL;
